unit SupplierItemType;
{

/* Initial. */

}
interface

uses
  JS;

type
  TSupplierItemType = class
  private
    fSupplierKey: String;
    fName: String;
    fActive: Boolean;
  public
    property SupplierKey: String read fSupplierKey;
    property Name: String read fName;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TSupplierItemType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fSupplierKey := String(JSObject_Type['supplierKey']);
    fName := String(JSObject_Type['name']);
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
